import { render } from "./AccountabilityChart.vue?vue&type=template&id=18a95d29&ts=true"
import script from "./AccountabilityChart.vue?vue&type=script&lang=ts"
export * from "./AccountabilityChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__